export function  checkStyle(object, inOut)
	{
    var obg =object;
	  var firstChild,secLastChild, lastChild, firstChildRSpan, currChild, currChildRSpan, preCount, currCount,preSibling;
    if(obg.currentTarget == undefined){
      preSibling = obg.previousElementSibling;
      currCount = obg.childElementCount;
    }
    else{
      preSibling = obg.currentTarget.previousElementSibling;
      currCount = obg.currentTarget.childElementCount;
    }
   
    if(preSibling !=null){
      firstChild = preSibling.firstChild;
      lastChild = preSibling.lastChild;
      secLastChild = lastChild.previousElementSibling;
      preCount = preSibling.childElementCount;
    }
   
    if(firstChild !=null)
	   firstChildRSpan =preSibling.firstChild.rowSpan;
  
     if(obg.currentTarget ==undefined)
       currChild =obg.firstChild;
     else
      currChild =obg.currentTarget.firstChild;
    
    if(currChild !=null)
	    currChildRSpan =currChild.rowSpan;
  
     if((currChild !=null) && ( currChildRSpan==undefined || currChildRSpan<=1)){ 
    	if ( (firstChild !=null && firstChild !=undefined) && (firstChildRSpan==undefined || firstChildRSpan>1 )){
       
        if(currCount ==preCount){ 
          checkStyle(preSibling,inOut);
        }
          else if(currCount < preCount){
            if(inOut == 1){
              firstChild.bgColor ="#F5F5F5";
              lastChild.bgColor ="#F5F5F5";
              secLastChild.bgColor ="#F5F5F5";
             
            }
            else if(inOut == 2){
              firstChild.bgColor ="";
              lastChild.bgColor ="";
              secLastChild.bgColor ="";
            }
          }
      }else{
        if((preSibling !=null) && (currCount <=preCount && firstChildRSpan>1))
          checkStyle(preSibling, inOut);
        }
      }
}

